import * as React from "react";
import DetailedPriceLayout from "../components/DetailedPriceLayout";

const ContainersDetailedPrice: React.FC = () => {
  return (
    <DetailedPriceLayout isPanelOpen={false} />
  );
};

export default ContainersDetailedPrice;